import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { parse } from 'query-string';

import { logout as _logout } from '../actions';
import { StoreState } from '../types';

import SetupCompleteImaUser from '../components/SetupCompleteImaUser';

export default connect(null, mapDispatchToProps)(
  class SetupCompleteImaUserContainer extends React.Component<
    SetupCompleteImaUserContainerProps,
    SetupCompleteImaUserContainerState
  > {
    constructor(props: SetupCompleteImaUserContainerProps) {
      super(props);

      const params = parse(location.search);
      let email = '';
      if (params.email) {
        // convert provided email to lowercase (LOGIN-144)
        email = params.email.toLowerCase();
      }

      this.state = {
        email
      };
    }

    render() {
      const { email } = this.state;
      return <SetupCompleteImaUser email={email} />;
    }

    componentWillMount() {
      // automatically log the user out and clear local storage
      this.props.logout(false);
      localStorage.clear();
    }
  }
);

export interface SetupCompleteImaUserContainerProps {
  // for logging the user out after completing their migration
  logout(redirect: boolean): void;
}

export interface SetupCompleteImaUserContainerState {
  email: string;
}

function mapDispatchToProps(dispatch: Dispatch<StoreState>) {
  return {
    logout(redirect: boolean) {
      dispatch(_logout(redirect));
    }
  };
}
